import {Button, Typography} from 'onboarding-components';
import * as React from 'react';

import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {AppContext} from 'common/onboarding/immersive-onboarding/types';
import {openDemoProjectSelectorModal} from 'common/widgets/demo-selector-modal';
import {IMMERSIVE_ASSETS} from 'common/onboarding/immersive-onboarding/assets';
import {track, TrackingEvent, TrackingProperty} from 'common/onboarding/immersive-onboarding/tracking';
import {ordinalizeNumber} from 'common/util';
import {openMediaModal} from 'common/widgets/tutorial-video-modal';
import {LEARN_MIXPANEL_YT_URL} from 'common/onboarding/immersive-onboarding/constants';

import styles from './welcome-v1.module.styl';

// eslint-disable-next-line react/destructuring-assignment
const WelcomeCTA = ({image, title, cta, name}) => {
  return (
    <>
      <div className={styles.welcomeCta} onClick={cta}>
        <img src={image} className={styles.welcomeCtaImage} />
        <Typography variant='headingXs' className={styles.welcomeCtaTitle}>
          {title}
        </Typography>
        <Button variant='inline' className={styles.welcomeCtaButton}>
          {name}
        </Button>
      </div>
    </>
  );
};

export const setupCTA = (userCount: number) => {
  return userCount > 1 ? `Continue Setup` : `Start Setup`;
};

export const WelcomeV1 = () => {
  const {currentProject} = React.useContext(AppContext);
  const {userCount, name} = currentProject.get().value || {};

  return (
    <div className={styles.welcomeContent}>
      {userCount > 1 && (
        <div className={styles.welcomeSubTitle}>
          <Typography tagName='span' variant='bodySm'>
            {`You're the `}
          </Typography>
          <Typography tagName='span' variant='bodySm' weight='bold'>
            {ordinalizeNumber(userCount)} person to join {name} 🎉
          </Typography>
        </div>
      )}
      <div className={styles.welcomeSubTitle}>
        <Typography tagName='span' variant='bodySm'>
          When you're ready to begin, select{` `}
        </Typography>
        <Typography tagName='span' variant='bodySm' weight='bold'>
          {setupCTA(userCount)}
        </Typography>
      </div>
      <div className={styles.welcomeCtas}>
        <WelcomeCTA
          image={IMMERSIVE_ASSETS.welcomeDemo}
          title={`Explore a demo project from your industry`}
          cta={() => {
            openDemoProjectSelectorModal(
              (ev) => {
                addToast({message: ev.detail.message, type: ToastType.ERROR});
              },
              {'is-new-tab': true},
            );
            track(TrackingEvent.WelcomeResourceClick, {[TrackingProperty.Name]: `demo project`});
          }}
          name={`Explore Demo`}
        />
        <WelcomeCTA
          image={IMMERSIVE_ASSETS.demoVideoThumbnail}
          title={`Learn how analytics helps businesses`}
          cta={() => {
            openMediaModal(
              (ev) => {
                if (ev.type === `error`) {
                  addToast({message: ev.detail.message, type: ToastType.ERROR});
                }
              },
              {
                'custom-url': LEARN_MIXPANEL_YT_URL,
                title: `How Analytics Helps Businesses`,
                width: 1024,
                height: 567,
              },
            );
            track(TrackingEvent.WelcomeResourceClick, {[TrackingProperty.Name]: `video`});
          }}
          name={`Watch Video - 1 min`}
        />
      </div>
    </div>
  );
};
